import { LiteratureFilter } from '../types/index';
import api from './api.ts';

export const categoryService = {
    async getCategories(litFilter: LiteratureFilter) {
        const response = await api.post('/categories/list', litFilter);
        return response.data;
    },

    async getCategoryValues(category: string, litFilter: LiteratureFilter) {
        const response = await api.post(`/categories/values/${category}`, litFilter);
        return response.data;
    },

    async mergeCategories(sourceCategory: string, targetCategory: string) {
        const response = await api.post('/categories/merge', {
            source_category: sourceCategory,
            target_category: targetCategory,
        });
        return response.data;
    },

    async mergeCategoryValues(category: string, sourceValue: string, targetValue: string) {
        const response = await api.post('/categories/merge-values', {
            category,
            source_value: sourceValue,
            target_value: targetValue,
        });
        return response.data;
    },

    async fixNestedCategories() {
        const response = await api.post('/categories/fix-nested');
        return response.data;
    },
};
